import React from "react";
import styles from "./Terms&Policy.module.css";

const PolicyIndex = () => {
  return (
    <div className={styles.container}>
      <div className={styles.content_wrap}>
        {/* title */}
        <div className={styles.page_subtitle}>
          <h1>PRIVACY POLICY</h1>
          <p>
            Personal details provided to HWL through this website will only be
            used in accordance with our privacy policy.
          </p>
        </div>

        {/* content */}
        <div className={styles.info_content}>
          {/* intro info */}
          <div className={styles.inner_content}>
            <h3>Sharing Information</h3>
            <p>
              Healthy World Lifestyle Sdn. Bhd. (“<strong>HWL</strong>”) and
              each of its respective related corporations (as the term is
              defined in the Companies Act 1965), affiliates and/or associated
              companies as data users (as the term is defined in the Personal
              Data Protection Act 2010) have or will collect, process, and use
              the following categories and/or types of personal data about the
              Customer:<br></br>
              [Customer Data: name, identity card number or passport number,
              nationality, place of birth, gender, date of birth, marital
              status, personal income etc and such other information required
              for the purposes below ;Contact data: home address, home phone
              number and mobile number, email address, work address etc.:]
              (collectively “<strong>Customer Data</strong>”)
            </p>
            <p>
              The Customer Data will be obtained from:<br></br>
              [information collected from you by us directly; and any
              information collected from your participation of our websites
              and/or any third party websites including but not limited to
              social networking websites]
            </p>
            <p>
              The Customer Data you have provided to us may be used for various
              purposes, including:<br></br> - the management of customer
              relationships;
              <ul>
                <li>To process a customers' request;</li>
                <li>
                  To send important notices, such as communications about
                  purchases;
                </li>
                <li>
                  To provide customers with information on its latest models and
                  offers;
                </li>
                <li>Update of customers' existing data;</li>
                <li>Marketing analysis and purposes;</li>
                <li>Statistical analysis and internal reporting;</li>
                <li>Regulatory compliance;</li>
                <li>
                  Marketing purposes such as sending Newletters, e-newsletters,
                  SMS blast;
                </li>
                <li>
                  Usage of personal information (ie: name, massage chair model
                  purchases) and images (ie. Self) for publicity/promotional
                  purposes.
                </li>
              </ul>
            </p>
            <p>
              (collectively "<strong>Purpose</strong>")
            </p>
            <div>
              <p>
                You have the rights to request access and/or to correct and
                limit the processing of your Customer Data in line with the
                applicable laws and/or any applicable data protection law. You
                are also requested to correct and/or amend your Customer Data to
                the extent you realise it is incorrect. Any of the above request
                should be directed to us via email to contact@bodyfriend.com.my
              </p>
              <p>
                Any inquiries or complaints with respect to your Customer Data
                should be channelled to us in this manner. In order to process
                your Customer Data, we are required to obtain your consent. Any
                request to access and/or correct the Personal Data may be
                subject to a prescribed fee. Please note that if you do not
                consent we cannot collect or use your Customer Data and will not
                be able to:
                <ul>
                  <li>Provide you with all of our products and services;</li>
                  <li>Process a transaction on your behalf;</li>
                  <li>Inform you of the latest promotions and offers;</li>
                  <li>
                    Inform you of the latest activities conducted by the
                    company;
                  </li>
                  <li>
                    Inform you in the event of you winning a contest organized
                    by HWL
                  </li>
                </ul>
              </p>
              <p>
                For the purpose of operating our business, we may transfer
                information between{" "}
                <strong>HEALTHY WORLD LIFESTYLE SDN. BHD.</strong> and our
                preferred service providers who use that information only to
                conduct <strong>HEALTHY WORLD LIFESTYLE SDN. BHD.</strong>{" "}
                business. For example, they may handle{" "}
                <strong>HEALTHY WORLD LIFESTYLE SDN. BHD</strong>’s data
                management, email distribution, market research, information
                analysis, information processing, fulfilling customer orders,
                delivering prodicts to you, managing and enhancing customer
                data, providing customer service, assessing your interest in our
                products and services and promotions management. We may also
                share your information to administer a website feature (e.g.,
                music download or race registration) and in that case will
                notify you before you give us your information. We provide our
                preferred service providers with the information they need to
                perform their services and work with them to respect and protect
                your information.
              </p>
              <p>
                From time to time we might establish a business relationship
                with carefully selected persons or companies whom we believe
                trustworthy. These are known as our Select Partners. In such
                cases we might share and cross-reference information, including
                personally identifiable information about you that will enable
                such persons or entities to contact you regarding products and
                services that may be of interest to you.
              </p>
              <p>
                We may provide your information to{" "}
                <strong>HEALTHY WORLD LIFESTYLE SDN. BHD.</strong> wholly-owned
                companies and affiliates, which may be outside Malaysia. We may
                provide information to other companies for purposes such as
                reporting and marketing.
              </p>
              <p>
                On rare occasions as may be necessary by law, legal process,
                litigation, we may disclose specific information to relevant
                bodies and Public or Governmental Authorities or such bodies
                within or outside your country of residence in compliance with
                the law and Order of a Court upon request, in response to a
                court order, when required by law, to enforce our website
                policies, or to protect our or others’ rights, property, or
                safety. We may also share information with companies assisting
                in fraud protection or investigation. We do not provide
                information to these bodies or companies for marketing or
                commercial purposes.
              </p>
            </div>
          </div>

          {/* protecting your information */}
          <div className={styles.inner_content}>
            <h2>Protecting Your Information</h2>
            <p>
              We use a variety of security measures, including sophisticated
              encryption and authentication tools to maintain the safety of your
              personal information. Your personal information is contained
              behind secure networks and is only accessible to a limited number
              of persons who have special access rights to such systems, and are
              required to keep the information confidential. Regardless of these
              efforts, no data transmission over the Internet can be guaranteed
              to be 100% secure.
            </p>
          </div>

          {/* cookies and pixel tags */}
          <div className={styles.inner_content}>
            <h2>Cookies and Pixel Tags</h2>
            <p>
              A cookie is a small removable data file that is stored by your web
              browser on your computer. Cookies allow us to enhance and
              personalize your online browsing experience. You can choose to
              have your computer warn you each time a cookie is being sent or
              you can choose to turn off all cookies. You do this through your
              browser (e.g. Internet Explorer or Google Chrome) settings. Each
              browser is a little different, so look at your browser Help menu
              to learn the correct way to modify your cookie settings. If you
              turn cookies off, you won’t have access to many features that make
              your site experience more efficient and some of our services will
              not function properly.
            </p>
          </div>

          {/* policy changes */}
          <div className={styles.inner_content}>
            <h2>Policy Changes</h2>
            <p>
              We may change our privacy policy from time to time. We encourage
              you to refer to this policy on an ongoing basis so that you
              understand our current privacy policy. This policy was last
              modified on April 6, 2015.
            </p>
          </div>

          {/* questions and feedback */}
          <div className={styles.inner_content}>
            <h2>Questions and Feedback</h2>
            <p>
              We welcome your questions, comments, and concerns about privacy.
              Please send us any and all feedback pertaining to privacy, or any
              other issue.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PolicyIndex;
